import axios from 'lib/axios'

const test360GetCompetencesForUser = async (user_test_id: number) => {
  const apiUrl = `/test360/config/test/${user_test_id}`

  try {
    const response = await axios.get(apiUrl)
    return response.data
  } catch (error) {
    console.error('error getting test 360 competences', error)
  }
}

export default test360GetCompetencesForUser
